import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRolesState } from 'src/types/Roles';

const initialState: IRolesState = {
  roles: []
};

export const roles = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    clearRoles: state => {
      state.roles = [];
    },
    setRoles: (state, action: PayloadAction<any>) => {
      state.roles = action.payload;
    }
  }
});

export const { clearRoles, setRoles } = roles.actions;
